import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20overlapping%20circles%20in%20coral%20orange%20and%20cream%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20textures%2C%20gentle%20color%20transitions%2C%20digital%20art%20style%2C%20clean%20and%20airy%20composition&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="蘑菇视频 - 短视频娱乐平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="蘑菇视频 - 短视频娱乐平台官方入口"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50" />
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading leading-tight">
            蘑菇视频
          </h1>
          <p className="text-base md:text-xl text-white/90 mb-3 max-w-2xl mx-auto">
            海量高清短视频内容随心看
          </p>
          <p className="text-sm md:text-lg text-white/70 mb-8 max-w-xl mx-auto">
            搞笑 · 生活 · 美食 · 时尚 · 旅行 · 科技 · 音乐 · 体育
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#download"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2"></i>
              下载蘑菇视频App
            </a>
            <Link
              to="/category/gaoxiao"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white rounded-full text-base font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/20"
            >
              <i className="ri-play-circle-line mr-2"></i>
              在线观看
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}